<template>
  <div class="hello">
    <span>Photos by Raphaël Rose</span><span>Website by Void Shelter</span><span><a href="mailto:contact@voidshelter.com">contact@voidshelter.com</a></span>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.hello{
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  color: white;
  font-size: 16px;
}
span{
  width: 33%;
}
@media screen and (max-width: 960px) {
  .hello {
    flex-direction: column;
  }
  span{
    width: 100%;
    margin: 5px 0;
  }
}


a{
  color: white;
  border-color: white;
}
</style>
